class breadcrumbController {
    /* @ngInject */
    constructor() {
    }
}

export default breadcrumbController;



// WEBPACK FOOTER //
// ./src/app/common/breadcrumb/breadcrumb.controller.js